export default __webpack_public_path__ + "static/media/misc-closet2-768w.0c2537cc.avif";